var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"child-profile"},[_c('avatar-profile-picture',{attrs:{"childId":_vm.childId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }